/* ═══════════════════════════════════════════════════════════
   Wokiee Custom Modifications
   ─ Minimum Quantity Enforcement
   ─ Minimum Cart Value (AJAX + static)
   ═══════════════════════════════════════════════════════════ */

/* ── 1. Minimum Quantity ───────────────────────────────────── */
(function () {
  function getMinQty() {
    var min = parseInt(window.wokieeMinQty, 10);
    if (!min || isNaN(min) || min <= 1) return 0;
    return min;
  }

  function getQtyInput() {
    return document.querySelector('.tt-product-single-info .tt-input-counter input[name="quantity"]') ||
           document.querySelector('.tt-input-counter input[name="quantity"]');
  }

  function getCounter() {
    return document.querySelector('.tt-product-single-info .tt-input-counter') ||
           document.querySelector('.tt-input-counter');
  }

  function updateMinusState(input, min) {
    var counter = getCounter();
    if (!counter || !input) return;

    var minusBtn = counter.querySelector('.minus-btn');
    if (minusBtn) {
      var qty = parseInt(input.value, 10);
      var shouldBlock = isNaN(qty) || qty <= min;

      minusBtn.disabled = shouldBlock;
      minusBtn.style.opacity = shouldBlock ? '0.4' : '';
      minusBtn.style.pointerEvents = shouldBlock ? 'none' : 'auto';
      minusBtn.style.cursor = shouldBlock ? 'not-allowed' : '';
    }
  }

    function bindCounterButtons(input, min) {
    var counter = getCounter();
    if (!counter || !input || counter.dataset.wkCounterBound === '1') return;

    var plusBtn = counter.querySelector('.plus-btn');
    var minusBtn = counter.querySelector('.minus-btn');

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        setTimeout(function () {
          updateMinusState(input, min);
        }, 30);
      }, true);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function (e) {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty <= min) {
          e.preventDefault();
          e.stopPropagation();
          input.value = min;
          updateMinusState(input, min);
          return false;
        }

        setTimeout(function () {
          var newQty = parseInt(input.value, 10);
          if (isNaN(newQty) || newQty < min) {
            input.value = min;
          }
          updateMinusState(input, min);
        }, 30);
      }, true);
    }

    counter.dataset.wkCounterBound = '1';
  }


  function enforceMinQty() {
    var min = getMinQty();
    if (!min) return;

    var input = getQtyInput();
    if (!input) return;

    input.setAttribute('min', min);

    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < min) {
      input.value = min;
    }

    updateMinusState(input, min);
    bindCounterButtons(input, min);

    if (input.dataset.wkMinQtyBound !== '1') {
      ['change', 'blur', 'input'].forEach(function (evt) {
        input.addEventListener(evt, function () {
          var val = parseInt(this.value, 10);
          if (isNaN(val) || val < min) {
            this.value = min;
          }
          updateMinusState(this, min);
        });
      });

      input.dataset.wkMinQtyBound = '1';
    }

    var form = input.closest('form') ||
               document.querySelector('.tt-add-basket-obj') ||
               document.querySelector('form[action="/cart/add"]');

    if (form && form.dataset.wkMinQtyFormBound !== '1') {
      form.addEventListener('submit', function (e) {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < min) {
          e.preventDefault();
          showMinQtyError(this, min);
        }
      });

      form.dataset.wkMinQtyFormBound = '1';
    }
  }

  function showMinQtyError(form, min) {
    var existing = form.querySelector('.tt-min-qty-error');
    if (existing) existing.remove();

    var msg = document.createElement('p');
    msg.className = 'tt-min-qty-error';
    msg.style.cssText = 'color:#c0392b;font-size:13px;margin-top:10px;font-weight:600;';
    msg.textContent = 'Minimum order quantity for this item is ' + min + '. Please update your quantity.';

    var btn = form.querySelector('.btn-addtocart, button[name="add"], button[type="submit"]');
    if (btn) btn.insertAdjacentElement('afterend', msg);
    else form.appendChild(msg);
  }

  function runMinQtyInit() {
    enforceMinQty();

    var tries = 0;
    var maxTries = 15;

    var timer = setInterval(function () {
      enforceMinQty();
      tries++;
      if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runMinQtyInit);
  } else {
    runMinQtyInit();
  }
})();

/* ── 2. Minimum Cart Value (AJAX drawer + static cart page) ── */
function wkFormatMoneyFromCents(cents) {
  var dollars = cents / 100;
  if (dollars % 1 === 0) {
    return '$' + dollars.toFixed(0);
  }
  return '$' + dollars.toFixed(2);
}

function wkCheckoutGuardToCart(e) {
  e.preventDefault();
  window.location.href = '/cart';
}

function wkToggleCheckoutControl(el, belowMinimum) {
  var isLink = el.tagName && el.tagName.toLowerCase() === 'a';

  if (isLink) {
    if (!el.dataset.wkOriginalHref) {
      el.dataset.wkOriginalHref = el.getAttribute('href') || '/checkout';
    }

    if (belowMinimum) {
      el.setAttribute('href', '/cart');
      el.setAttribute('aria-disabled', 'true');
      el.style.opacity = '0.5';
      el.style.pointerEvents = 'auto';

      if (!el.dataset.wkGuardBound) {
        el.addEventListener('click', wkCheckoutGuardToCart);
        el.dataset.wkGuardBound = '1';
      }
    } else {
      el.setAttribute('href', el.dataset.wkOriginalHref);
      el.removeAttribute('aria-disabled');
      el.style.opacity = '';
      el.style.pointerEvents = '';

      if (el.dataset.wkGuardBound) {
        el.removeEventListener('click', wkCheckoutGuardToCart);
        el.removeAttribute('data-wk-guard-bound');
      }
    }
  } else {
    if (belowMinimum) {
      el.setAttribute('disabled', 'disabled');
      el.style.opacity = '0.5';
      el.style.pointerEvents = 'none';
    } else {
      el.removeAttribute('disabled');
      el.style.opacity = '';
      el.style.pointerEvents = '';
    }
  }
}

function wkGetIncentiveBox() {
  return document.getElementById('wk-cart-incentives');
}

function wkGetIncentiveConfig() {
  var box = wkGetIncentiveBox();
  if (!box) return null;

  var tiers = [];

  if (box.dataset.tier1Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier1Threshold || '0', 10),
      label: box.dataset.tier1Label || ''
    });
  }

  if (box.dataset.tier2Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier2Threshold || '0', 10),
      label: box.dataset.tier2Label || ''
    });
  }

  if (box.dataset.tier3Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier3Threshold || '0', 10),
      label: box.dataset.tier3Label || ''
    });
  }

  tiers = tiers.filter(function (tier) {
    return tier.threshold > 0 && tier.label;
  }).sort(function (a, b) {
    return a.threshold - b.threshold;
  });

  return {
    box: box,
    minCartCents: parseInt(box.dataset.minCartCents || '0', 10),
    progressEnabled: box.dataset.progressEnabled === 'true',
    tiers: tiers
  };
}

function wkRenderCartIncentives(cartTotalCents) {
  var config = wkGetIncentiveConfig();
  if (!config) return;

  var box = config.box;
  var minNotice = box.querySelector('.wk-cart-incentives__notice--minimum');
  var rewardNotice = box.querySelector('.wk-cart-incentives__notice--reward');
  var progressWrap = box.querySelector('.wk-cart-incentives__progress');
  var progressFill = box.querySelector('.wk-cart-incentives__fill');
  var progressCaption = box.querySelector('.wk-cart-incentives__caption');

  if (minNotice) {
    minNotice.style.display = 'none';
    minNotice.innerHTML = '';
  }
  if (rewardNotice) {
    rewardNotice.style.display = 'none';
    rewardNotice.innerHTML = '';
  }
  if (progressWrap) {
    progressWrap.style.display = 'none';
  }
  if (progressFill) {
    progressFill.style.width = '0%';
  }
  if (progressCaption) {
    progressCaption.innerHTML = '';
  }

  if (config.minCartCents > 0 && cartTotalCents < config.minCartCents && minNotice) {
    var minRemaining = config.minCartCents - cartTotalCents;
    minNotice.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(minRemaining) + '</strong> more to reach the minimum order of <strong>' + wkFormatMoneyFromCents(config.minCartCents) + '</strong>.';
    minNotice.style.display = 'block';
  }

  if (config.tiers.length) {
    var unlockedTier = null;
    var nextTier = null;

    for (var i = 0; i < config.tiers.length; i++) {
      if (cartTotalCents >= config.tiers[i].threshold) {
        unlockedTier = config.tiers[i];
      } else {
        nextTier = config.tiers[i];
        break;
      }
    }

    if (rewardNotice) {
      if (!unlockedTier && nextTier) {
        rewardNotice.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(nextTier.threshold - cartTotalCents) + '</strong> more for the next reward.';
        rewardNotice.style.display = 'block';
      } else if (unlockedTier && nextTier) {
        rewardNotice.innerHTML = '<strong>' + unlockedTier.label + '</strong><br><span class="wk-cart-incentives__subline">Add <strong>' + wkFormatMoneyFromCents(nextTier.threshold - cartTotalCents) + '</strong> more for the next reward.</span>';
        rewardNotice.style.display = 'block';
      } else if (unlockedTier && !nextTier) {
        rewardNotice.innerHTML = '<strong>' + unlockedTier.label + '</strong>';
        rewardNotice.style.display = 'block';
      }
    }

    if (config.progressEnabled && progressWrap && progressFill && progressCaption) {
      var finalTier = config.tiers[config.tiers.length - 1];
      var percent = Math.max(0, Math.min(100, (cartTotalCents / finalTier.threshold) * 100));

      progressFill.style.width = percent + '%';
      progressWrap.style.display = 'block';

      if (cartTotalCents >= finalTier.threshold) {
        progressCaption.innerHTML = 'Free shipping is ready on this order.';
      } else {
        progressCaption.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(finalTier.threshold - cartTotalCents) + '</strong> more for free shipping.';
      }
    }
  }
}

function wokieeCheckMinCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var incentiveConfig = wkGetIncentiveConfig();
      var minCents = 0;

      if (incentiveConfig && incentiveConfig.minCartCents > 0) {
        minCents = incentiveConfig.minCartCents;
      } else {
        minCents = parseInt(
          document.body.getAttribute('data-min-cart-cents') || '0', 10
        );
      }

      document.querySelectorAll('.tt-cart-min-notice-dynamic').forEach(function (el) {
        el.remove();
      });

      var controls = document.querySelectorAll(
        '[name="checkout"], a[href="/checkout"], a[href*="/checkout?"]'
      );

      var belowMinimum = minCents > 0 && cart.total_price < minCents;

      controls.forEach(function (el) {
        wkToggleCheckoutControl(el, belowMinimum);
      });

      if (incentiveConfig) {
        wkRenderCartIncentives(cart.total_price);
      } else if (belowMinimum) {
        var remainingCents = minCents - cart.total_price;
        var remainingText = wkFormatMoneyFromCents(remainingCents);
        var minimumText = wkFormatMoneyFromCents(minCents);

        controls.forEach(function (el) {
          var parent = el.parentNode;
          if (!parent) return;

          var notice = document.createElement('p');
          notice.className = 'tt-cart-min-notice-dynamic';
          notice.style.cssText = [
            'background:#fff8e1',
            'border-left:3px solid #ffc107',
            'border-radius:3px',
            'padding:10px 14px',
            'margin-bottom:12px',
            'color:#856404',
            'font-size:13px',
            'font-weight:500'
          ].join(';');
          notice.textContent = 'Add ' + remainingText + ' more to reach the minimum order of ' + minimumText + '.';

          parent.insertBefore(notice, el);
        });
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wokieeCheckMinCart);
} else {
  wokieeCheckMinCart();
}

/* Fallback: re-check cart minimum whenever Wokiee updates the cart UI */
(function () {
  var cartTarget = document.querySelector('.tt-cart-holder, .tt-cart-bootstrap, #tt-pageContent');
  if (!cartTarget) return;
  var observer = new MutationObserver(function () {
    wokieeCheckMinCart();
  });
  observer.observe(cartTarget, { childList: true, subtree: true });
})();

/* ── 3. Cart Line Minimum Quantity Enforcement ─────────────── */
(function () {
  function wkClampCartQtyInput(input) {
    if (!input) return;

    var min = Number(input.getAttribute('data-min-qty')) || Number(input.getAttribute('min')) || 1;
    var val = Number(input.value);

    if (isNaN(val) || val < min) {
      input.value = min;
      val = min;
    }

    var counter = input.closest('.tt-input-counter');
    if (counter) {
      var minusBtn = counter.querySelector('.minus-btn');
      var plusBtn = counter.querySelector('.plus-btn');
      var max = Number(input.getAttribute('size')) || 999999;

      if (minusBtn) {
        if (val <= min) {
          minusBtn.style.display = 'none';
          minusBtn.style.pointerEvents = 'none';
          minusBtn.style.opacity = '0.4';
        } else {
          minusBtn.style.display = '';
          minusBtn.style.pointerEvents = 'auto';
          minusBtn.style.opacity = '';
        }
      }

      if (plusBtn) {
        if (val >= max) {
          plusBtn.style.display = 'none';
        } else {
          plusBtn.style.display = '';
        }
      }
    }
  }

  function wkBindCartQtyGuards() {
    var inputs = document.querySelectorAll('.tt-shopcart-table--js input[name="updates[]"]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      if (input.dataset.wkCartQtyBound === '1') {
        wkClampCartQtyInput(input);
        return;
      }

      ['input', 'change', 'blur'].forEach(function (evt) {
        input.addEventListener(evt, function () {
          wkClampCartQtyInput(input);
        });
      });

      var counter = input.closest('.tt-input-counter');
      if (counter) {
        var minusBtn = counter.querySelector('.minus-btn');
        var plusBtn = counter.querySelector('.plus-btn');

        if (minusBtn) {
          minusBtn.addEventListener('click', function (e) {
            var min = Number(input.getAttribute('data-min-qty')) || Number(input.getAttribute('min')) || 1;
            var val = Number(input.value);

            if (isNaN(val) || val <= min) {
              e.preventDefault();
              e.stopPropagation();
              input.value = min;
              wkClampCartQtyInput(input);
              return false;
            }

            setTimeout(function () {
              wkClampCartQtyInput(input);
            }, 30);
          }, true);
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            setTimeout(function () {
              wkClampCartQtyInput(input);
            }, 30);
          }, true);
        }
      }

      input.dataset.wkCartQtyBound = '1';
      wkClampCartQtyInput(input);
    });
  }

  function wkInitCartQtyGuards() {
    wkBindCartQtyGuards();

    var tries = 0;
    var maxTries = 15;
    var timer = setInterval(function () {
      wkBindCartQtyGuards();
      tries++;
      if (tries >= maxTries) clearInterval(timer);
    }, 300);

    var cartTable = document.querySelector('.tt-shopcart-table--js') || document.querySelector('#tt-pageContent');
    if (!cartTable || cartTable.dataset.wkCartObserverBound === '1') return;

    var observer = new MutationObserver(function () {
      wkBindCartQtyGuards();
    });

    observer.observe(cartTable, { childList: true, subtree: true });
    cartTable.dataset.wkCartObserverBound = '1';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wkInitCartQtyGuards);
  } else {
    wkInitCartQtyGuards();
  }
})();